/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const { roleInfo = {} } = currentUser ?? {};
  return {
    totalStatistics: roleInfo?.permissions?.indexOf('totalStatistics') > -1,
    projectMenu: roleInfo?.permissions?.indexOf('projectMenu') > -1,
    saleMenu: roleInfo?.permissions?.indexOf('saleMenu') > -1,
    incomeMenu: roleInfo?.permissions?.indexOf('incomeMenu') > -1,
    costMenu: roleInfo?.permissions?.indexOf('costMenu') > -1,
    pettyCashMenu: roleInfo?.permissions?.indexOf('pettyCashMenu') > -1,
    userMenu: roleInfo?.permissions?.indexOf('userMenu') > -1,
    roleMenu: roleInfo?.permissions?.indexOf('roleMenu') > -1,
    operateMenu: roleInfo?.permissions?.indexOf('operateMenu') > -1,
  };
}
